import React, { useState, useContext } from 'react';
import { Box, useTheme, AppBar, Toolbar, Typography, Avatar, IconButton, Badge, Tooltip, Drawer } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import SportsRoundedIcon from '@mui/icons-material/SportsRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { ActiveTeamContext } from '../../context/ActiveTeamContext';
import { useAuth } from '../../context/AuthContext';
import Settings from '../../pages/user/Settings';
import Profil from '../../pages/user/Profil';
import useDataFetch from '../../utils/useDataFetch';

const Header = () => {
    const theme = useTheme();
    const { activeTeamId } = useContext(ActiveTeamContext);
    const { user } = useAuth();
    const activeTeamRole = user?.teams?.find(t => t?.team_id?.toString() === activeTeamId?.toString())?.rolle;
    const isTrainer = user?.role === 'trainer' || user?.isAdmin || user?.role === 'super_admin' || activeTeamRole === 'trainer' || activeTeamRole === 'admin';
    const roleLabel = isTrainer ? 'Coach' : 'Player';
    const navigate = useNavigate();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [profilOpen, setProfilOpen] = useState(false);

    const { data: unreadData } = useDataFetch({ url: '/notifications/unread-count' });
    const unreadCount = unreadData?.unreadCount || 0;

    return (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1100, px: { xs: 1.5, md: 3 }, pt: 2, pb: 0 }}>
            <AppBar
                position="static"
                elevation={0}
                sx={{
                    borderRadius: "12px",
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(20px)',
                }}
            >
                <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1.5, sm: 2 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
                        <img src="../../../SGElbergen1982.png" alt="SGE Logo" style={{ height: '36px', filter: theme.palette.mode === 'dark' ? 'brightness(1.2)' : 'none' }} />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1.5 } }}>
                        <Tooltip title="Benachrichtigungen">
                            <IconButton color="inherit" onClick={() => navigate('/notifications')} sx={{ p: 1 }}>
                                <Badge
                                    badgeContent={unreadCount}
                                    color="primary"
                                    sx={{ '& .MuiBadge-badge': { fontWeight: 800, color: '#000' } }}
                                >
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton>
                        </Tooltip>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                ml: 1,
                                p: 0.5,
                                pr: { xs: 0.5, md: 2 },
                                borderRadius: '8px',
                                border: '1px solid',
                                borderColor: 'transparent',
                                transition: 'all 0.2s',
                                cursor: 'pointer',
                                '&:hover': {
                                    bgcolor: 'rgba(190, 242, 100, 0.1)',
                                    borderColor: 'primary.main'
                                }
                            }}
                            onClick={() => setProfilOpen(true)}
                        >
                            <Avatar
                                sx={{
                                    width: 32,
                                    height: 32,
                                    bgcolor: 'primary.main',
                                    color: '#000',
                                    fontWeight: 800,
                                    fontSize: '0.8rem',
                                    border: '2px solid',
                                    borderColor: 'background.paper'
                                }}
                            >
                                {`${user?.first_name?.[0] || ''}${user?.last_name?.[0] || ''}`}
                            </Avatar>
                            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                                <Typography variant="caption" sx={{ fontWeight: 800, lineHeight: 1, display: 'block', color: 'primary.main' }}>
                                    {user?.first_name || 'Gast'}
                                </Typography>
                                <Typography variant="caption" sx={{ fontSize: '0.6rem', opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                    {user?.role === 'trainer' ? 'Coach' : 'Player'}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Drawers */}
            <Drawer
                anchor="top"
                open={settingsOpen}
                onClose={() => setSettingsOpen(false)}
                PaperProps={{
                    sx: { height: '90vh', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', p: 2 }
                }}
            >
                <Settings onClose={() => setSettingsOpen(false)} />
            </Drawer>

            <Drawer
                anchor="top"
                open={profilOpen}
                onClose={() => setProfilOpen(false)}
                PaperProps={{
                    sx: { height: '90vh', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', p: 2 }
                }}
            >
                <Profil onClose={() => setProfilOpen(false)} />
            </Drawer>
        </Box>
    );
};

export default Header;